import { createContext } from 'react'

const CrmTutorialTourContext = createContext({});

export default CrmTutorialTourContext;
